
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PiedrasNaturalesSection from '../../components/feature/PiedrasNaturalesSection';

export default function ProductosPage() {

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="bg-white min-h-screen flex items-center">
        <div className="w-full mx-auto text-center" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
          <h1 
            className="font-light text-gray-900" 
            style={{ 
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(2.5rem, 5vw, 7rem)',
              marginBottom: 'clamp(1rem, 2vh, 3rem)'
            }}
          >
            PRODUCTOS
          </h1>
          <p 
            className="text-gray-600 max-w-[1400px] mx-auto leading-relaxed" 
            style={{ 
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(1rem, 1.2vw, 1.5rem)',
              padding: '0 clamp(1rem, 2vw, 3rem)'
            }}
          >
            Descubre nuestra colección de ambientes diseñados para inspirarte. Cada espacio refleja un estilo único, 
            combinando funcionalidad y estética para crear el baño de tus sueños.
            <br /><br />
            Desde el minimalismo contemporáneo hasta el lujo más sofisticado, encuentra la inspiración perfecta para tu proyecto.
          </p>
        </div>
      </div>

      <PiedrasNaturalesSection />

      <Footer />
    </div>
  );
}
